import { render, staticRenderFns } from "./SalaryIndividualDeductionRegistration.vue?vue&type=template&id=64bc4870&"
import script from "./SalaryIndividualDeductionRegistration.vue?vue&type=script&lang=js&"
export * from "./SalaryIndividualDeductionRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports